
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import * as n from "@/types/notifications";
import { configStore } from "@/store/store-accessor";
import TroubleshootingModal from "./TroubleshootingModal.vue";
import CopyButton from "@/components/Reusable/CopyButton.vue";
import { jsonStringifyOrUndefined } from "@/util/json-stringify-or-undefined";

@Component({
  components: {
    CopyButton,
    TroubleshootingModal
  }
})
export default class AjaxCodeError extends Vue {
  @Prop()
  value!: n.AjaxCodeErrorNotification;

  moreInfoDialogOpen = false;

  get notificationHeading() {
    const v = this.value;
    return `${v.requestDetails?.friendlyName} - Error Code ${v.requestDetails?.responseCode}`;
  }

  get ajaxErrorNotificationMessage() {
    return (
      this.value.errorDetails?.message ??
      this.value.errorMessage ??
      "The task failed due a problem on the server side."
    );
  }

  get valueForClipboard(): string | undefined {
    return jsonStringifyOrUndefined(this.value);
  }

  get troubleShootingModalOptions() {
    return { title: "AJAX Error" };
  }

  get loginURL() {
    return configStore.neededData?.adminLoginUrl;
  }

  get isResponseCodeUnauthorized() {
    return this.value.requestDetails?.responseCode === "401";
  }

  setMoreInfoDialogOpen(open: boolean) {
    this.moreInfoDialogOpen = open;
  }
}
